import { render } from "./ITCGridComponent.vue?vue&type=template&id=1657634d&scoped=true"
import script from "./ITCGridComponent.vue?vue&type=script&lang=js"
export * from "./ITCGridComponent.vue?vue&type=script&lang=js"

import "./ITCGridComponent.vue?vue&type=style&index=0&id=1657634d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1657634d"]])

export default __exports__